import { render } from "./vlogin.vue?vue&type=template&id=a88666be&scoped=true"
import script from "./vlogin.vue?vue&type=script&lang=js"
export * from "./vlogin.vue?vue&type=script&lang=js"

import "./vlogin.vue?vue&type=style&index=0&id=a88666be&scoped=true&lang=css"

import exportComponent from "/Users/jx/project/wld/nongxin-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a88666be"]])

export default __exports__